import { apiDelete, apiGet, apiPost, apiPut } from "./client";
import type { Profile } from "@ceo-cmd/shared";
import type { ProfilePatch } from "@/types";

/** Fetch the user's profile. */
export async function getProfile(): Promise<Profile> {
  const res = await apiGet<{ profile: Profile | null }>("/api/profile");
  return (res.profile ?? {}) as Profile;
}

/** Partial update to the profile. */
export async function updateProfile(patch: ProfilePatch): Promise<Profile> {
  const res = await apiPut<{ profile: Profile }>("/api/profile", patch);
  return res.profile;
}

/** Upload an avatar image to the user's private S3-backed profile. */
export async function uploadProfileAvatar(dataUrl: string): Promise<Profile> {
  const res = await apiPost<{ profile: Profile }>("/api/profile/avatar", {
    dataUrl,
  });
  return res.profile;
}

/** Remove the current avatar from the profile and S3. */
export async function removeProfileAvatar(): Promise<Profile> {
  const res = await apiDelete<{ profile: Profile }>("/api/profile/avatar");
  return res.profile;
}
